
import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, Image, TouchableOpacity, Switch, TextInput, ActivityIndicator, Linking  } from 'react-native';
// import * as Facebook from 'expo-facebook';
import logo from './../assets/logo-psihomaestru-3.png'; 
import { Ionicons } from '@expo/vector-icons';
import { AntDesign } from '@expo/vector-icons';  


export default function Signup({navigation, route}) {

    const { tokenKey } = route.params;
    const { name } = route.params;
    const { Diagnostic } = route.params;
    const { PUN_utilizatorID } = route.params;
    const { age } = route.params;
    const { ocupation } = route.params;
    const { mediu } = route.params;
    const { sex } = route.params;
    const { currentDate } = route.params;
    const { sectiune } = route.params;

    const [isLoggedin, setLoggedinStatus] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isImageLoading, setImageLoadStatus] = useState(false);

    const [isLoading, setLoading] = useState(true);
    const [shouldShowMandatory, setShouldShowMandatory] = useState(false);
    const [shouldShowMandatoryS, setShouldShowMandatoryS] = useState(false);

    const [isEnabled1, setIsEnabled1] = useState(false);
    const toggleSwitch1 = () => setIsEnabled1(previousState => !previousState);
    const [isEnabled2, setIsEnabled2] = useState(false);
    const toggleSwitch2 = () => setIsEnabled2(previousState => !previousState);
    const [isEnabled3, setIsEnabled3] = useState(false);
    const toggleSwitch3 = () => setIsEnabled3(previousState => !previousState);



    // const facebookLogIn = async () => {
    //     try {
    //     const {
    //         type,
    //         token,
    //         expires,
    //         permissions,
    //         declinedPermissions,
    //     } = await Facebook.logInWithReadPermissionsAsync({
    //         permissions: ['public_profile'],
    //     });
    //     if (type === 'success') {
    //         // Get the user's name using Facebook's Graph API
    //         fetch(`https://graph.facebook.com/me?access_token=${token}&fields=id,name,email,picture.height(500)`)
    //         .then(response => response.json())
    //         .then(data => {
    //             setLoggedinStatus(true);
    //             setUserData(logo);
    //         })
    //         .catch(e => console.log(e))
    //     } else {
    //         // type === 'cancel'
    //     }
    //     } catch ({ message }) {
    //     alert(`Facebook Login Error: ${message}`);
    //     setLoggedinStatus(true);
    // }
    // }



    
    //Post search method to find email utilizatori
    let [utilizatorID, setutilizatorID] = useState('');
    let [U_status, setU_Status] = useState('');
    let [preNume, setpreNume] = useState('');
    let [length, setLength] = useState();
    const SearchEmailUtilizator = async  () => {
        try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator', {
            method:'POST',
            headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+tokenKey
            },
            body: JSON.stringify(
            {
                "useremail": email
            }
            )
        }
        )
        const json = await response.json();
        console.log(json);
        setLength(json.length);
            if(json.length >= 1) {
            setLoggedinStatus(true);
            //   setUserData(data); //email exists
            setutilizatorID(json[0].utilizatorID);
            setU_Status(json[0].status);
            setpreNume(json[0].preNume);
            return;
            }
            setLoading(false);
            navigation.replace('Inregistrare...', 
              {
                email:email,
                name:name,
                tokenKey:tokenKey, 
                Diagnostic:Diagnostic, 
                PUN_utilizatorID:PUN_utilizatorID, 
                age:age, 
                mediu:mediu, 
                ocupation:ocupation, 
                sex:sex,
                currentDate: currentDate,
                sectiune: sectiune,
              }
            );
          } catch (error) {
        console.error(error);
        setLoading(false);
        } finally {
        setLoading(false);
        }
    };

    const logout = () => {
        setLoggedinStatus(false);
        setUserData(null);
        setImageLoadStatus(false);
        setEmail('');
        setisValidEmail(false);
    }

    let [email, setEmail] = useState('');
    const checkTextInput = () => {
        if (isValidEmail === false) {
            setShouldShowMandatory(true);
            return;
        } 
        setShouldShowMandatory(false);
        if ((isEnabled1 === false) || (isEnabled2 === false) || (isEnabled3 === false)) {
          setShouldShowMandatoryS(true);
          return;
        }
        setShouldShowMandatoryS(false);
        setLoading(true);
        SearchEmailUtilizator();
    }

    let [isValidEmail, setisValidEmail] = useState(false);
    const validate = (enteredemail) => {
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(enteredemail).toLowerCase());
    }


    // console.log('U_status: '+ U_status)
    // console.log('utilizatorID:'+utilizatorID);
    // console.log('token:'+tokenKey);
    // console.log('preNume:'+preNume);
    // console.log('length:'+length);
    // console.log('email:'+email);
    // console.log('isLoggedin:'+isLoggedin);
    // console.log('isValidEmail:'+isValidEmail);
    // console.log('PUNutilizatorID:'+PUN_utilizatorID);
    // console.log('age: '+age)
    // console.log('mediu: '+mediu);
    // console.log('ocupation: '+ocupation);
    // console.log('sex: '+sex );

    // console.log('age: '+age)
    // console.log('mediu: '+mediu);
    // console.log('ocupation: '+ocupation);
    // console.log('sex: '+sex );
    // console.log('isEnabled1: '+isEnabled1 );
    // console.log('isEnabled2: '+isEnabled2 );
    // console.log('isEnabled2: '+isEnabled3 );

    
    // console.log('Diagnostic: '+ Diagnostic);

    useEffect(() => {
        setShouldShowMandatory(false);
        setLoading(false);
      }, []);

    return (
        isLoggedin ?
        // userData ?
            <View style={styles.container}>
            {/* <Image
                style={{ width: 200, height: 200, borderRadius: 50 }}
                source={{ uri: userData.picture.data.url }}
                onLoadEnd={() => setImageLoadStatus(true)} /> */}
            <Image style={styles.logo} source={logo} />
            {/* <ActivityIndicator size="large" color="#0000ff" animating={!isImageLoading} style={{ position: "absolute" }} /> */}
            <Text style={styles.MainText}>{preNume} ți-am gasit emailul într-un cont existent!{"\n"}{"\n"}
            Hai să te logăm in sistem, te rog apasă butonul de mai jos:
            </Text>
            <TouchableOpacity
            style={styles.loginBtn}
            onPress={ () => {
              navigation.push('Login',
                  {
                    email:email,
                    tokenKey:tokenKey, 
                    PUN_utilizatorID:PUN_utilizatorID, 
                  
              })}}
            >
                <AntDesign name="login" size={24} color="#628914" />
            </TouchableOpacity>
            <Text style={styles.MainText2}>sau mergi înapoi sa introduci emailul din nou!
            </Text>
            <TouchableOpacity 
                style={styles.logoutBtn} 
                onPress={logout}>
                <Ionicons name="backspace-outline" size={24} color="#628914" />
            </TouchableOpacity>
            </View> 
            // : null
        :

        <View style={styles.container}>
            <Image style={styles.logo} source={logo} />
            <Text style={styles.MainText}>Introdu adresa de email</Text>
            <TextInput 
            name='email'
            style={styles.input}
            placeholder='ex: dorina@gmail.com'
            onChangeText={
                (val) => {setEmail(val);setisValidEmail(validate(val))}
            }
            />
            {shouldShowMandatory ? (
            <Text style={styles.inputMando}>Te rog sa completezi emailul in formatul corespunzator!</Text>
            ) : null
            }
            <Text style={styles.label1}>
              Am citit și sunt de acord cu {"\n"} {' '}
              <Text
                style={styles.hyperlinkStyle}
                onPress={() => {
                  Linking.openURL('https://psihomaestru.ro/termeni-si-conditii');
                }}>
                Termenii și Condițiile
              </Text>
            </Text>   
            <Switch
              trackColor={{ false: '#767577', true: '#628914' }}
              style={styles.Switch1}
              thumbColor={isEnabled1 ? '#EFEB88' : '#f4f3f4'}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggleSwitch1}
              value={isEnabled1}
            />
            <Text style={styles.label2}>
              Am citit și sunt de acord cu cu {"\n"}  {' '}
              <Text
                style={styles.hyperlinkStyle}
                onPress={() => {
                  Linking.openURL('https://psihomaestru.ro/politica-de-confidentialitate');
                }}>
                Politica de Confidențialitate
              </Text>
             </Text> 
             <Switch
                  trackColor={{ false: '#767577', true: '#628914' }}
                  style={styles.Switch2}
                  thumbColor={isEnabled2 ? '#EFEB88' : '#f4f3f4'}
                  ios_backgroundColor="#3e3e3e"
                  onValueChange={toggleSwitch2}
                  value={isEnabled2}
              />
              <Text style={styles.label3}>
                Confirm că am peste 16 ani.
              </Text>
              <Switch
                  trackColor={{ false: '#767577', true: '#628914' }}
                  thumbColor={isEnabled3 ? '#EFEB88' : '#f4f3f4'}
                  style={styles.Switch3}
                  ios_backgroundColor="#3e3e3e"
                  onValueChange={toggleSwitch3}
                  value={isEnabled3}
              />
              {shouldShowMandatoryS ? (
              <Text style={styles.inputMando}>Te rog să citești și sa confirmi că esti de acord cu: {"\n"} 
              - Termenii și Condițiile{"\n"} 
              - Politica de Confidențialitate{"\n"} 
              - Confirmă că ai peste 16 ani</Text>
                ) : null
              } 

            {isLoading ? 
            ( 
              <ActivityIndicator size="large" color="#628914" style={{position: "absolute", top: 450, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
            ) : (
            <TouchableOpacity
            style={styles.buttonPlay}
            onPress={() => {
                checkTextInput();
                }}
            >
            <Ionicons name="md-enter" size={24} color="#628914" />
            </TouchableOpacity>
              )
            }
            {/*<TouchableOpacity style={styles.loginBtn} onPress={facebookLogIn}>
            <Text style={{ color: "#fff" }}>Login with Facebook</Text>
            </TouchableOpacity> */}
        </View>
    );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e9ebee',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    backgroundColor: '#EFEB88',
    position: 'absolute',
    top: 260,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logoutBtn: {
    backgroundColor: '#EFEB88',
    position: "absolute",
    top: 400,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logo: {
    position: "absolute",
    alignSelf: 'flex-start',
    top: 30,
    left: 20,
    width: 200, 
    height: 50,
  },
  MainText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position:"absolute",
    top:150,
  },
  MainText2: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position:"absolute",
    top:340,
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position:"absolute",
    top:180,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMando: {
    position:"absolute",
    top:400,
    color: 'red'
  },
  buttonPlay: {
    position: 'absolute',
    top:480,
    alignSelf: 'center',
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  label1: {
    color: "#3E473A",
    fontSize: 14,
    top: 260,
    position: 'absolute',
  },
  Switch1: {
    top:250, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  label2: {
    color: "#3E473A",
    fontSize: 14,
    top: 310,
    position: 'absolute',
  },
  Switch2: {
    top:300, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  label3: {
    color: "#3E473A",
    fontSize: 14,
    top: 360,
    position: 'absolute',
  },
  Switch3: {
    top:350, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  hyperlinkStyle: {
    color: 'blue',
  },
});